/* eslint-disable @next/next/no-img-element */

import React from "react";
import Image from 'next/image'
import { Speaker } from "@/models/speaker";
import styles from "../Schedule/Schedule.module.css";
import { useGetEventsBySpeakerQuery } from "@/redux/features/api-slice";
import { format } from "date-fns";
import { EventItem, MySchedule } from "@/models/event-item";
import { useAppSelector } from "@/redux/store";
import { setMySchedule } from "@/redux/features/schedule-slice";
import { addMyScheduleToDB, removeMyScheduleFromDB } from "@/helpers/server-actions/events-collection";
import { toast } from "react-toastify";
import CustomToast from "../CustomToast/CustomToast";
import { useDispatch } from "react-redux";

interface SpeakerProfileModalProps {
    onClose: () => void;
    speaker: Speaker;
    isSchedule?: boolean;
}

const SpeakerProfileModal: React.FC<SpeakerProfileModalProps> = ({ speaker, onClose, isSchedule }) => {

    const { data: events } = useGetEventsBySpeakerQuery(speaker.id || '');
    const user = useAppSelector((state) => state.appReducer.userData);
    const dispatch = useDispatch();

    const myScheduleData = useAppSelector(
        (state) => state.scheduleReducer.mySchedule
    );


    const handleClose = (e: any) => {
        if (e.target.id === 'wrapper') onClose();
    }

    const isInMySchedule = (schedule: EventItem) => {
        return myScheduleData.some((mySchedule) => mySchedule.id === schedule.id);
    }

    const updateMySchedule = async (event: EventItem) => {
        const mySchedule = myScheduleData;
        const myScheduleIndex = mySchedule.findIndex(
            (mySchedule) => mySchedule.id === event.id
        );

        if (myScheduleIndex !== -1) {
            const mutableMySchedule = [...mySchedule];
            mutableMySchedule.splice(myScheduleIndex, 1);
            dispatch(setMySchedule(mutableMySchedule));
            if (user) {
                await removeMyScheduleFromDB(event.id, user.uid);
            }
        } else {
            const mutableMySchedule = [...mySchedule];
            mutableMySchedule.push({
                id: event.id,
                timestamp: new Date(),
            } as MySchedule);
            dispatch(setMySchedule(mutableMySchedule));
            if (user) {
                await addMyScheduleToDB(event.id, user.uid);
            }
        }
    };

    const handleMyScheduleClick = async (schedule: EventItem) => {
        const isMySchedule = myScheduleData.some(
            (mySchedule) => mySchedule.id === schedule.id
        )

        await updateMySchedule(schedule);
        {
            isMySchedule
                ? toast(<CustomToast message="Event removed from My Schedule!" />)
                : toast(<CustomToast message="Event added to My Schedule!" />);
        }

    };

    return (
        <div id="wrapper" onClick={handleClose} aria-hidden="true" className="fixed top-0 right-0 bg-black bg-opacity-60 h-full w-full flex items-center justify-center" style={{ 'zIndex': 100 }}>
            <div className="relative p-0 md:w-[900px] w-[330px] max-w-full max-h-full overflow-y-auto">

                <div className="bg-white rounded-[20px] overflow-hidden shadow dark:bg-gray-700">
                    <div className="flex md:flex-row flex-col flex-wrap justify-start bg-gray-700">
                        <div className="md:w-[40%] w-full flex md:h-[400px] h-[188px] relative">
                            <Image
                                layout="fill"
                                objectFit="cover"
                                src={speaker.image}
                                alt="Profile picture" />
                        </div>

                        <div className="flex flex-col md:w-[60%] w-full md:h-[400px] h-[300px] justify-start bg-white md:pr-4 pr-2 pt-4 md:pb-6 pb-2">
                            <div className="md:flex hidden justify-end">
                                <button onClick={() => onClose()} type="button" className="text-black h-[40px] w-[40px] text-sm inline-flex justify-center items-center" data-modal-hide="default-modal">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M2.46456 0.956045C2.31456 0.812795 2.13006 0.67967 1.92681 0.609545C1.71906 0.53792 1.48581 0.53117 1.26156 0.65342C1.09097 0.749154 0.935009 0.868874 0.798436 1.00892C0.634936 1.17242 0.520936 1.32842 0.443311 1.47167C0.320686 1.69629 0.327436 1.92917 0.399061 2.13692C0.469186 2.34054 0.602311 2.52467 0.745561 2.67542C1.52331 3.49254 3.40244 5.4508 6.14556 8.21004C3.40206 10.9689 1.52331 12.9275 0.745936 13.7443C0.602686 13.8947 0.469561 14.0792 0.399436 14.2824C0.327811 14.4902 0.321061 14.723 0.443311 14.9477C0.521686 15.0909 0.635311 15.2469 0.798811 15.4104C0.962311 15.5739 1.11831 15.6879 1.26156 15.7659C1.48619 15.8882 1.71906 15.8818 1.92681 15.8098C2.13044 15.7397 2.31456 15.6065 2.46531 15.4633C3.28206 14.6863 5.24069 12.8075 7.99956 10.0637C10.7584 12.8072 12.7171 14.6859 13.5346 15.4637C13.6846 15.6069 13.8691 15.74 14.0723 15.8102C14.2801 15.8818 14.5133 15.8889 14.7376 15.7663C14.9081 15.6707 15.0641 15.5511 15.2007 15.4112C15.3406 15.2746 15.4602 15.1186 15.5558 14.948C15.6784 14.7234 15.6717 14.4905 15.6001 14.2828C15.5299 14.0795 15.3968 13.895 15.2536 13.7447C14.4758 12.9272 12.5967 10.9689 9.85319 8.20967C12.5967 5.4508 14.4754 3.49217 15.2532 2.67542C15.3964 2.52467 15.5296 2.34054 15.5997 2.13692C15.6713 1.92917 15.6784 1.69629 15.5558 1.47167C15.4602 1.30123 15.3406 1.1454 15.2007 1.00892C15.0641 0.868874 14.9081 0.749154 14.7376 0.65342C14.5129 0.53117 14.2801 0.53792 14.0723 0.609545C13.8691 0.67967 13.6846 0.812795 13.5342 0.956045C12.7167 1.73379 10.7584 3.61254 7.99919 6.35604C5.24106 3.61254 3.28206 1.73379 2.46531 0.95642L2.46456 0.956045Z" fill="#333E48" />
                                    </svg>
                                    <span className="sr-only">Close modal</span>
                                </button>
                            </div>

                            <div className="flex flex-col justify-start md:ml-[40px] ml-[25px] overflow-auto">
                                <span className="font-bold text-2xl" style={{
                                    color: "var(--Neutrals-Secondary-Dark-Neutral---Thunder)"
                                }}>{speaker.name}</span>
                                <span className="font-normal text-base mt-1" style={{
                                    color: "var(--Neutrals-Secondary-Dark-Neutral---Thunder)"
                                }}>{speaker.designation}</span>
                                <div className="flex gap-4 items-end">
                                    {speaker.linkedinUrl && <Image
                                        width={22}
                                        height={22}
                                        onClick={() => {
                                            if (speaker.linkedinUrl) window.open(speaker.linkedinUrl, '_blank')
                                        }}
                                        className="mt-2 cursor-pointer pb-6"
                                        src={"/images/speaker_linkedIn_icon.svg"}
                                        alt="Profile picture" />}
                                    {speaker.instagramUrl && <Image
                                        width={22}
                                        height={22}
                                        onClick={() => {
                                            if (speaker.instagramUrl) window.open(speaker.instagramUrl, '_blank')
                                        }}
                                        className="mt-2 cursor-pointer pb-6"
                                        src={"/images/instagram-icon.svg"}
                                        alt="Profile picture" />}

                                </div>
                                <div className="flex mb-2 leading-5 pr-14 overflow-auto">
                                    <div className="pb-16">
                                        <span className="font-normal text-xs" style={{
                                            color: "var(--Neutrals-Secondary-Dark-Neutral---Thunder)"
                                        }}
                                        >{speaker.bio}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {isSchedule && (<div className="bg-white w-full">
                            <p className={styles.schedule}>schedule</p>

                            {events && (

                                events.map((event, index) => (
                                    <div className="mx-5 mb-4" key={index}>
                                        <div className="flex flex-col w-full border-t pt-4 border-button-enabled-color">
                                            <div className="flex flex-row justify-between w-full">
                                                <div className="flex gap-2">

                                                    <div className="flex items-center gap-1">

                                                        <div className="text-[0.93rem] leading-5">
                                                            {format(event.startTime.toDate(), "hh:mm a")}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`vertical-${event.vertical}-bg rounded-3xl`}>
                                                    <div className=" uppercase text-xs font-bold leading-[0.93rem] tracking-widest px-5 py-2">
                                                        {event.vertical}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" font-bold text-lg uppercase">{event.title}</div>
                                            <div className="flex items-center">
                                                <div className="h-5 w-5 relative">
                                                    <Image src="/icons/Location.svg" alt="time" fill />
                                                </div>
                                                <div className="text-[0.81rem] leading-5"><p className={styles["location-typo"]}>
                                                    <a
                                                        href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                                            event.location ? event.location : "Edmonton, AB"
                                                        )}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {event.location ? event.location : "Edmonton, AB"}
                                                    </a>
                                                </p></div>
                                            </div>
                                            <div className="mt-2 text-[0.81rem] leading-5">
                                                {event.description}
                                            </div>
                                            <div className="flex justify-end">
                                                {isInMySchedule(event) ? (
                                                    <Image
                                                        src="/images/schedule-filled-heart.svg"
                                                        alt="arrow-right"
                                                        width={30}
                                                        height={30}
                                                        className="cursor-pointer"
                                                        onClick={() => handleMyScheduleClick(event)}
                                                    />
                                                ) : (<Image
                                                    src="/images/schedule-unfilled-heart.svg"
                                                    alt="arrow-right"
                                                    width={30}
                                                    height={30}
                                                    className="cursor-pointer"
                                                    onClick={() => handleMyScheduleClick(event)}
                                                />)}
                                            </div>
                                        </div>
                                    </div>
                                ))


                            )}

                        </div>)}




                        <div className="md:hidden flex justify-center items-center h-[50px] shadow border-t-[1px] bg-white">
                            <button onClick={() => onClose()}>
                                <span className="text-black">Close</span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default SpeakerProfileModal;
